export const GET_SUPPLIERS = "GET_SUPPLIERS";
export const GET_SUPPLIERS_LIST_TYPE_DOCUMENT = "GET_SUPPLIERS_LIST_TYPE_DOCUMENT";
export const GET_STATE_LOADING = "GET_STATE_LOADING";